class ShippingBannerUpdater extends HTMLElement {
  constructor() {
    super();
    this.threshold = 2500; // £25 in pence
    this.messageElement = document.getElementById('shipping-message');
    
    // Initialize
    this.updateBanner();
    
    // Listen for cart updates (Dawn theme specific)
    document.addEventListener('cart:refresh', this.updateBanner.bind(this));
    
    // For add to cart button clicks in Dawn
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.addEventListener('cart:refresh', this.updateBanner.bind(this));
    }
  }

  updateBanner() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const remaining = this.threshold - cart.total_price;
        
        if (cart.total_price >= this.threshold) {
          this.messageElement.innerHTML = '<span style="color: var(--color-success);">✓ Your order qualifies for FREE shipping!</span>';
        } else {
          const pounds = (remaining / 100).toFixed(2);
          this.messageElement.innerHTML = `Add <strong>£${pounds}</strong> more for FREE shipping`;
        }
      })
      .catch(error => console.error('Error updating shipping banner:', error));
  }
}

// Register the custom element
customElements.define('shipping-banner-updater', ShippingBannerUpdater);

// Initialize after DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  const banner = document.createElement('shipping-banner-updater');
  document.body.appendChild(banner);
});
